import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

export default {
  methods: {
    formatDate(dateStr, fmtStr = null) {
      if (!dateStr) return null;
      const dateObj = new Date(dateStr);
      if (fmtStr) {
        const d = dayjs(dateStr);
        return d.format(fmtStr);
      }
      return dateObj.toLocaleString();
    },
    formatRelative(dateStr) {
      if (!dateStr) return null;
      const dateObj = new Date(dateStr);
      return dayjs(dateObj).fromNow();
    },
  },
};
